import { IdAndName } from 'src/service/view-model/base/IdAndName'
import { findReferenceObject } from 'src/service/view-model/base/Reference.utils'

export interface CurrencyObject extends IdAndName {
  group: string
}

const group1 = ''

export const CURRENCIES: CurrencyObject[] = [
  { id: 'CHF', name: 'Swiss Franc (CHF)', group: group1 },
  { id: 'EUR', name: 'Euro (EUR)', group: group1 },
  { id: 'GBP', name: 'British Pound Sterling (GBP)', group: group1 },
  { id: 'INR', name: 'Indian Rupee (INR)', group: group1 },
  { id: 'USD', name: 'United States Dollar (USD)', group: group1 },
]

export const getCurrencyObject = (currencyCode: string | undefined): CurrencyObject | undefined => {
  return findReferenceObject(CURRENCIES, currencyCode, 'id')
}

export const getCurrencyName = (currencyCode: string | undefined): string => {
  const currencyObject = getCurrencyObject(currencyCode)
  return currencyObject ? currencyObject.name : ''
}
